import PropTypes from 'prop-types';
// External Imports
import { Component } from 'react';

// Internal Imports
import { isInProduct } from '../../utils/inProduct.mjs';
import { logger } from '../../utils/rollbar.mjs';
import { getGoBaseUrl, isTrackingDisabled } from '../../utils/url.mjs';
import { getScriptStatuses, loadWebToolsModuleIfNeeded } from '../../utils/webTools.mjs';

// Component Definition
class CampaignsTracker extends Component {
  constructor(props) {
    super(props);
    this.campaignsTracker = undefined;
  }

  componentDidMount() {
    this.trackPageView();
  }

  componentDidUpdate(previousProps) {
    const { shortlinkCode } = this.props;
    if (shortlinkCode !== previousProps.shortlinkCode) {
      this.trackPageView();
    }
  }

  // eslint-disable-next-line class-methods-use-this -- this is a renderless component
  render() {
    return null; // eslint-disable-line unicorn/no-null -- React expects non-rendering to use null
  }

  async trackPageView() {
    const { shortlinkCode } = this.props;

    if (isTrackingDisabled() || isInProduct(globalThis.location.search)) {
      return;
    }

    if (!this.campaignsTracker) {
      await loadWebToolsModuleIfNeeded();
      const marketingTracker = globalThis.MarketingTracker;
      if (!marketingTracker) {
        logger.warning(
          'Marketing tracker unavailable after webtools initialisation',
          getScriptStatuses(),
        );
        return;
      }
      this.campaignsTracker = new marketingTracker.CampaignsTracker({
        host: getGoBaseUrl(),
      });
    }
    this.campaignsTracker.trackPageview(shortlinkCode);
  }
}

CampaignsTracker.propTypes = {
  shortlinkCode: PropTypes.string.isRequired,
};

// Module Exports
export { CampaignsTracker };
